<!-- Component can be used in microscope and periscope -->
<template>
  <svg :class="{ [`icon-${color}`]: !!color }" :width="size" :height="size" viewBox="0 0 24 24">
    <path :d="path" />
  </svg>
</template>

<script lang="ts" setup>
// Note: viewBox is hardcoded for mdi icons.
withDefaults(
  defineProps<{
    path: string
    size?: number | string
    color?: 'white' | 'blue' | 'green' | 'red' | 'disabled' | 'orange'
  }>(),
  {
    size: 24,
    color: undefined,
  },
)
</script>

<style lang="scss" scoped>
svg {
  fill: currentColor !important;

  &.icon-blue {
    fill: var(--color-icon-accent) !important;
  }

  &.icon-red {
    fill: var(--color-icon-danger) !important;
  }

  &.icon-green {
    fill: var(--color-icon-success) !important;
  }

  &.icon-disabled {
    fill: var(--color-icon-disabled) !important;
  }

  &.icon-warning {
    fill: var(--color-icon-warning) !important;
  }

  &.icon-white {
    fill: #ffffff !important;
  }
}
</style>
